import React from 'react';

import {GameCenterWidgetState} from "../models/game-center-widget.state";
import {observer} from "mobx-react";
import styles from "../styles/game-center-widget.module.scss";
import classNames from "classnames";
import {GameCenterWidgetContentMatchTab} from "./tabs/game-center-widget.content.match-tab";
import {GameCenterWidgetContentLineupsTab} from "./tabs/game-center-widget.content.lineups-tab";
import {GameCenterWidgetContentBoxScoresTab} from "./tabs/game-center-widget.content.box-scores-tab";
import {GameCenterWidgetContentStatsTab} from "./tabs/game-center-widget.content.stats-tab";
import {GameCenterWidgetContentH2hTab} from "./tabs/game-center-widget.content.h2h-tab";
import {GameCenterWidgetContentTrendsTab} from "./tabs/game-center-widget.content.trends-tab";
import {GameCenterWidgetContentOddsTab} from "./tabs/game-center-widget.content.odds-tab";
import {GameCenterWidgetContentPropositionBetsTab} from "./tabs/game-center-widget.content.proposition-bets-tab";
import {BookmakersReviewWidgetAsync} from "../../bookmakers-review-widget/components/bookmakers-review-widget.async";
import {GameCenterWidgetContentNewsTab} from "./tabs/game-center-widget.content.news-tab";
import {IntersectionObserver} from "../../../core/components/intersection-observer/intersection-observer";
import {GameCenterWidgetPointByPointNewsTab} from "./tabs/game-center-widget.point-by-point.news-tab";

class GameCenterWidgetContentProps {
  state: GameCenterWidgetState;
  matchupId: String;
  gameId: Number;
  location: Location;
}

export const GameCenterWidgetContent = observer(({
                                                   controller,
                                                   matchupId,
                                                   gameId,
                                                   location,
                                                   onTabChange,
                                                   scrollToTop
                                                 }: GameCenterWidgetContentProps) => {
  const {state} = controller;
  const {device: {isSmallView}} = controller;

  const {
    isWidget,
    shouldRenderBookmakerReview,
    showOdds
  } = state;

  const widgetProps = {
    matchupId,
    gameId: gameId || controller.state.gameId,
    location,
    showOdds
  };

  const tabProps = {
    controller,
    ...widgetProps
  }

  const matchTabProps = {
    ...tabProps,
    onSeeAllClick: (index) => {
      scrollToTop?.()
      onTabChange(index)
    },
  }

  return (
      <div className={classNames(styles.content, {[styles.small_view]: isSmallView}, {[styles.widgets]: isWidget})}>
        <GameCenterWidgetContentMatchTab {...matchTabProps}/>
        <GameCenterWidgetContentLineupsTab {...tabProps}/>
        <GameCenterWidgetContentBoxScoresTab {...tabProps}/>
        <GameCenterWidgetContentStatsTab {...tabProps}/>
        <GameCenterWidgetContentH2hTab {...tabProps}/>
        <GameCenterWidgetContentPropositionBetsTab {...tabProps}/>
        <GameCenterWidgetContentTrendsTab {...tabProps}/>
        <GameCenterWidgetContentOddsTab {...tabProps}/>
        <GameCenterWidgetContentNewsTab {...tabProps}/>
        <GameCenterWidgetPointByPointNewsTab {...tabProps}/>
        {
            shouldRenderBookmakerReview && <IntersectionObserver className={classNames(styles.widget_wrapper)}>
            <BookmakersReviewWidgetAsync/>
          </IntersectionObserver>
        }

      </div>
  )
});
